// assets/blog-filter.js
class BlogFilter {
  constructor() {
  
    this.currentPage = 1;
    this.allArticles = [];
    this.categorySelect = document.getElementById('categories');
    this.yearSelect = document.getElementById('year');
    this.blogPostsContainer = document.querySelector('.blog-posts');
    this.paginationContainer = document.querySelector('.pagination');
    this.loader = document.querySelector('#blog-loader');
    
    const blogSettings = document.getElementById('blog-settings');
      this.ARTICLES_PER_PAGE = blogSettings.dataset.perPage || 5 ; 
this.showExcerpt = blogSettings.dataset.showExcerpt === 'true';
this.showDate = blogSettings.dataset.showDate === 'true';
this.showAuthor = blogSettings.dataset.showAuthor === 'true';
this.showCommentsCount = blogSettings.dataset.showCommentsCount === 'true';
this.showCategory = blogSettings.dataset.showCategory === 'true';
    
    this.init();
  }

  init() {
    this.loadArticles();
    this.attachEventListeners();
    this.filterArticles();
  }

  loadArticles() {
    try {
      const articlesData = JSON.parse(document.getElementById('articles-data').textContent);
      console.log("articlesData", articlesData);
      this.allArticles = articlesData.map(article => ({
        id: article.id,
        title: article.title,
        url: article.url,
        excerpt: article.excerpt,
        tags: article.tags,
        publishedDate: article.published_at,
        author: article.author,
        year: new Date(article.published_at).getFullYear().toString(),
        featuredImage: article.image,
        content: article.content_html
      }));
    } catch (error) {
      console.error('Error loading articles:', error);
      this.allArticles = [];
    }
  }

  attachEventListeners() {
    this.categorySelect.addEventListener('change', () => this.handleFilterChange());
    this.yearSelect.addEventListener('change', () => this.handleFilterChange());
  }

  handleFilterChange() {
    this.currentPage = 1;
    this.showLoader();
    this.filterArticles();
  }

    showLoader() {
      console.log("hettt")
    this.loader.style.display = 'block'; // Show loader
  }

  hideLoader() {
    this.loader.style.display = 'none'; // Hide loader
  }
  filterArticles() {
    const selectedYear = this.yearSelect.value;
    const selectedCategory = this.categorySelect.value;
    
    const filteredArticles = this.allArticles.filter(article => {
      console.log("article",article)
      const yearMatch = selectedYear === 'All' || article.year === selectedYear;
      const categoryMatch = selectedCategory === 'All posts' || article.tags.includes(selectedCategory);
       return yearMatch && categoryMatch;
    });

    this.displayArticles(filteredArticles);
    this.updatePagination(filteredArticles);
  }

  displayArticles(filteredArticles) {
    const startIndex = (this.currentPage - 1) * this.ARTICLES_PER_PAGE;
    const endIndex = startIndex + this.ARTICLES_PER_PAGE;
    const articlesToShow = filteredArticles.slice(startIndex, endIndex);
    
    this.blogPostsContainer.innerHTML = '';
    
    if (articlesToShow.length === 0) {
      const noResults = document.createElement('div');
      noResults.className = 'no-results-message';
      noResults.textContent = 'No articles found matching your criteria.';
      this.blogPostsContainer.appendChild(noResults);
      this.hideLoader()
      return;
    }
    
    articlesToShow.forEach(article => {
      this.blogPostsContainer.appendChild(this.createArticleCard(article));
    });
    this.hideLoader()
  }

 createArticleCard(article) {
  const card = document.createElement('article');
  card.className = 'blog-post-card snap-center group';
  card.setAttribute('data-tags', article.tags.join(','));

  const publishedDate = new Date(article.publishedDate);
  const formattedDate = publishedDate.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric'
  });

  let cardContent = `
    <a href="${article.url}" class="blog-post-card__figure rounded">
      ${this.showCategory && article.tags.length > 0 ? article.tags.map(tag => `<span class="badge badge--primary">${tag}</span>`).join('') : ''}
    ${article.featuredImage ? `
          <img 
            src="${article.featuredImage}" 
            alt="${article.title}"
            loading="lazy"
             srcset="
            ${article.featuredImage}?width=300 300w,
            ${article.featuredImage}?width=400 400w,
            ${article.featuredImage}?width=500 500w,
            ${article.featuredImage}?width=600 600w,
            ${article.featuredImage}?width=800 800w,
            ${article.featuredImage}?width=1000 1000w,
            ${article.featuredImage}?width=1200 1200w,
            ${article.featuredImage}?width=1400 1400w
          "
          width="1513"
           sizes="(max-width: 699px) 100vw, (max-width: 1149px) calc(100vw / 2 - 40px), (max-width: 1399px) calc(min(100vw, 1300px) / 3 - 40px), calc(min(100vw, 1300px) / 3 - 80px)"
            class="w-full h-full object-cover zoom-image"
          >
        ` : ''}
    </a>
    <div class="blog-post-card_new__info">
      <div class="v-stack gap-4 sm:gap-5">
        <div class="v-stack gap-3 sm:gap-4">
          <p class="h3">
            <a href="${article.url}">${article.title}</a>
          </p>
        ${article.excerpt ? `<p>${article.excerpt}</p>` : ''}
        </div>
        <div class="blog-post-card__meta">
          ${this.showDate ? `
            <div class="text-with-icon link-faded">
              <svg role="presentation" fill="none" focusable="false" stroke-width="1.5" width="16" height="16" class="icon icon-blog-date" viewBox="0 0 16 16">
                <path d="M5.372 1v2.877M10.455 1v2.877" stroke="currentColor" stroke-linecap="round"></path>
                <path d="M14.338 7.632H1.497l.179-4.57 6.164-.448 6.497.448v4.57Z" fill="currentColor" fill-opacity=".12"></path>
                <path d="M1.224 12.073c.183 1.631 1.508 2.925 3.147 3.004a73.18 73.18 0 0 0 3.546.083c1.256 0 2.413-.028 3.546-.083 1.639-.079 2.964-1.374 3.146-3.004.124-1.099.225-2.224.225-3.37 0-1.147-.102-2.273-.225-3.371-.182-1.631-1.507-2.925-3.146-3.004a73.22 73.22 0 0 0-3.546-.083 73.22 73.22 0 0 0-3.546.083c-1.639.079-2.964 1.374-3.147 3.004C1.101 6.43 1 7.556 1 8.703c0 1.146.102 2.272.224 3.37ZM1.331 7.202h13.24" stroke="currentColor"></path>
              </svg>
              <span class="text-sm">${formattedDate}</span>
            </div>
          ` : ''}
          ${this.showAuthor ? `
            <div class="text-with-icon link-faded">
              <svg role="presentation" fill="none" focusable="false" stroke-width="1.5" width="16" height="16" class="icon icon-blog-author" viewBox="0 0 16 16">
                <path d="M8 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM4 9a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 1.5-2.5 3-4 3H8c-1.5 0-4-1.5-4-3V9z" fill="currentColor"></path>
              </svg>
              <span class="text-sm">${article.author || 'Unknown Author'}</span>
            </div>
          ` : ''}
          ${this.showCommentsCount && article.comments_enabled ? `
            <div class="text-with-icon link-faded">
              <svg role="presentation" fill="none" focusable="false" stroke-width="1.5" width="16" height="16" class="icon icon-blog-comment" viewBox="0 0 16 16">
                <path d="M4 6h8M4 10h6M12 4V2H4v2H2v8h2v2h8v-2h2V4h-2z" stroke="currentColor"></path>
              </svg>
              <a href="${article.url}#blog-post-comments" class="text-sm">${article.comments_count} Comments</a>
            </div>
          ` : ''}
        </div>
      </div>
    </div>
  </div>
  `;

  card.innerHTML = cardContent;
  return card;
}


 updatePagination(filteredArticles) {
  const totalPages = Math.ceil(filteredArticles.length / this.ARTICLES_PER_PAGE);
  
  if (totalPages <= 1) {
    this.paginationContainer.style.display = 'none';
    return;
  }

  this.paginationContainer.style.display = '';
  
  // Construct the pagination HTML
  let paginationHTML = `
    <nav class="pagination" role="navigation" aria-label="Pagination navigation">
  `;
  
  // Previous button
 paginationHTML += `
  ${this.currentPage > 1 
  ? `<a class="pagination__item group" 
        rel="prev" 
        aria-label="Go to page ${this.currentPage - 1}" 
        href="?page=${this.currentPage - 1}">
        <span class="animated-arrow animated-arrow--reverse"></span>
     </a>` 
  : `<span class="pagination__item--disabled animated-arrow animated-arrow--reverse custom-arrow"></span>`}
`;
  
  
  // Current page indicator
  paginationHTML += `
    <span class="pagination__current">${this.currentPage} &nbsp;&nbsp;/&nbsp;&nbsp; ${totalPages}</span>
  `;
  
  // Next button
  paginationHTML += `
   ${this.currentPage !== totalPages
  ? `
    <a class="pagination__item ${this.currentPage === totalPages ? 'pagination__item--disabled' : ''} group" rel="next" aria-label="Go to page ${this.currentPage + 1}" href="?page=${this.currentPage + 1}" ${this.currentPage === totalPages ? 'aria-disabled="true"' : ''}>
      <span class="animated-arrow"></span>
    </a>`:`<span class="pagination__item--disabled animated-arrow custom-arrow"></span>`}
  `;
  
  paginationHTML += '</nav>';
  
  // Inject the pagination HTML into the container
  this.paginationContainer.innerHTML = paginationHTML;
  
  // Add event listeners to the buttons
  this.paginationContainer.querySelector('[rel="prev"]')?.addEventListener('click', (e) => {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.displayArticles(filteredArticles);
      this.updatePagination(filteredArticles);
      e.preventDefault();
      this.scrollToTop();
    }
  });

  this.paginationContainer.querySelector('[rel="next"]')?.addEventListener('click', (e) => {
    if (this.currentPage < totalPages) {
      this.currentPage++;
      this.displayArticles(filteredArticles);
      this.updatePagination(filteredArticles);
      e.preventDefault();
      this.scrollToTop();
    }
  });
}

// Scroll to the top of the page
scrollToTop() {
  window.scrollTo({
    top: 500,
    behavior: 'smooth' // This will make the scroll smooth
  });
}


}

// Initialize the blog filter when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new BlogFilter();
});
